export default __webpack_public_path__ + "static/media/illustrate-document-png.30670a86.svg";